import {ModuleWithProviders, AfterViewInit, ElementRef, Component, OnInit} from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import {CommonModule} from "@angular/common";
import {NgModule, ViewChild, Inject} from "@angular/core";
import {ModalDirective} from 'ngx-bootstrap';
//import {ComponentBase} from "../modules/component-base";
import {UIHelper} from "../uihelper";
//import {User} from "../model/app/User";
import {FormGroup} from "@angular/forms";
import {RecaptchaModule} from 'ng-recaptcha';
import {RecaptchaFormsModule} from 'ng-recaptcha/forms';
import {ActivatedRoute} from "@angular/router";
import {ComponentBase} from "../modules/component-base";
import {User} from "../model/app/User";
import {UserWoClient} from "../model/app/UserWoClient";

//import {commonComponents} from "../common.component";

@Component({
    moduleId: __moduleName,
    selector: 'account-handling',
    templateUrl: './account-handling.component.html'
})
export class AccountHandlingComponent extends ComponentBase implements OnInit {

    //@ViewChild("loginUserModal") loginUserModal: ModalDirective;
    @ViewChild("registerUserModal") registerUserModal: ModalDirective;
    @ViewChild("forgotUserPasswordModal") forgotUserPasswordModal: ModalDirective;
    @ViewChild("resetUserPasswordModal") resetUserPasswordModal: ModalDirective;

    registerUserFormGroup: FormGroup;
    registerError = '';
    captchaResolved = false;
    reCaptchaKey = null;
    registerView = 1;
    forgottenPwView = 1;
    forgottenPw = '';
    forgottenPwError = '';
    captchaResponse = '';

    resetNewPw = '';
    resetNewPwRe = '';
    resetPwError = '';
    resetPwToken = '';

    regToken = '';
    user: any;

    createClient = false;

    ngOnInit() {
    }

    forgotUserPassword() {
        //this.loginUserModal.hide();
        this.forgottenPw = '';
        this.forgottenPwView = 1;
        this.forgotUserPasswordModal.show();
    }

    setCaptchaResolved(event) {
        this.captchaResponse = event;
        this.captchaResolved = true;
    }

    /*
        doLoginUser() {
            disableUser();
            UIHelper.doPostJSON(this.http, this.appComponent, getApiUrl() + '/login',
                {
                    email: this.loginUsername,
                    password: this.loginPassword
                })
                .subscribe(
                    resultData => {
                        enableUser();
                        if (typeof resultData.token !== 'undefined') {
                            this.loginBadMessage = '';
                            UIHelper.doPostJSON(this.http, this.appComponent, '/login', resultData).subscribe(
                                resultData => {
                                    if (resultData == true) {
                                        window.location.reload();
                                    }
                                }
                            );
                        }
                        else {
                            try {
                                this.loginBadMessage = resultData.result.resultMessage;
                            } catch (e) {
                                this.loginBadMessage = 'Unknown error, please try again!';
                            }
                        }
                    }
                );
        }
    */
    doRegisterUser() {
        if (!this.registerUserFormGroup.valid) {
            this.registerError = 'Kérem töltse ki a mezőket megfelelően!';
            return;
        }
        if (this.user.password != this.user.passwordre) {
            this.registerError = 'A megadott jelszavak nem egyeznek!';
            return;
        }
        let sendUser = this.shallowCloneObject(this.user);
        this.registerError = '';
        delete sendUser._inputFields;
        disableUser();
        UIHelper.doPostJSON(this.http, this.appComponent, getApiUrl() + '/register?act=register&tkn=' + this.regToken, sendUser, true, false, true).subscribe(
            resultData => {
                enableUser();
                if (typeof resultData.felhasznalo_id != 'undefined') {
                    this.registerView = 2;
                } else {
                    this.registerError = 'Ismeretlen hiba, kérem próbálja újra!';
                }
            },
            error => {
                enableUser();
                try {
                    if (typeof error.error.message !== 'undefined') {
                        this.registerError = error.message;
                    } else {
                        if (typeof error.error.title != 'undefined') {
                            this.registerError = '<b>' + error.error.title + '</b>' + ' - ' + error.error.description;
                        } else {
                            this.registerError = 'Ismeretlen hiba, kérem próbálja újra!';
                        }
                    }
                } catch (e) {
                }
            });
    }

    doForgotUserPassword() {
        if (this.forgottenPw.trim() == '') {
            this.forgottenPwError = 'Kérem adja meg e-mail az címét!';
            return;
        }
        disableUser();
        UIHelper.doPostJSON(this.http, this.appComponent, getApiUrl() + '/requestpwreset', {email: this.forgottenPw}, true, false, true).subscribe(
            resultData => {
                enableUser();
                this.forgottenPwError = '';
                this.forgottenPwView = 2;
            },
            error => {
                enableUser();
                try {
                    if (error.status == 404) {
                        this.forgottenPwError = 'A megadott e-mail cím helytelen!';
                    } else {
                        this.forgottenPwError = 'Ismeretlen hiba, kérem próbálja újra!';
                    }
                } catch (e) {
                    this.forgottenPwError = 'Ismeretlen hiba, kérem próbálja újra!';
                }
            });
    }

    showPasswordReset(token) {
        this.resetPwToken = token;
        this.resetUserPasswordModal.show();
    }

    doResetPassword() {
        if (this.resetNewPw == '') {
            this.resetPwError = 'Kérem adja meg a jelszót!';
            return;
        }
        if (this.resetNewPwRe == '') {
            this.resetPwError = 'Kérem adja meg a jelszót mégegyszer!';
            return;
        }
        if (this.resetNewPw != this.resetNewPwRe) {
            this.resetPwError = 'A megadott jelszavak nem egyeznek meg!';
            return;
        }
        disableUser();
        UIHelper.doPostJSON(this.http, this.appComponent, getApiUrl() + '/pwreset', {
            token: this.resetPwToken,
            password: this.resetNewPw
        }, true, false, true).subscribe(
            resultData => {
                enableUser();
                this.appComponent.addGrowlInfoMessage('A jelszó mentése megtörtént, beléphet!');
                this.resetUserPasswordModal.hide();
            },
            error => {
                enableUser();
                try {
                    if (error.status == '401') {
                        this.resetPwError = 'A jelszóemlékeztető hivatkozása lejárt, kérjen újat!';
                        return;
                    }
                    if (typeof error.message != 'undefined') {
                        this.resetPwError = error.message;
                    } else {
                        this.resetPwError = 'Ismeretlen hiba, kérem próbálja újra!';
                    }
                } catch (e) {
                    this.resetPwError = 'Ismeretlen hiba, kérem próbálja újra!';
                }
            });
    }

    showRegistration(token) {
        this.regToken = token;
        UIHelper.doPostJSON(this.http, this.appComponent, getApiUrl() + '/register?act=chk&tkn=' + this.regToken, {}, true, false, true).subscribe(
            resultData => {
                /*this.createClient = resultData.createclient;
                if (this.createClient) {
                    this.user = new User();
                }
                else {
                    this.user = new UserWoClient();
                }*/
                this.user = new UserWoClient();
                this.user.email = resultData.email;
                this.user.nev = resultData.name;
                this.registerError = '';
                this.registerView = 1;
                this.captchaResolved = false;
                let formItems = {};
                UIHelper.populateFormGroup(this.user._inputFields, formItems);
                this.registerUserFormGroup = new FormGroup(formItems);
                //this.loginUserModal.hide();
                this.registerUserModal.show();

            },
            error => {
                enableUser();
                if (typeof error.error['description'] != 'undefined') {
                    this.appComponent.addGrowlErrorMessage(error.error['title'], error.error['description']);
                } else {
                    this.appComponent.addGrowlErrorMessage('Hiba', 'Ismeretlen hiba, kérem próbálja újra!');
                }
            }
        );
    }

}
